export type ResultExit = { href: string; label: string };

export function editorExit(stageId: string): ResultExit {
  return { href: `/stage-maker/${encodeURIComponent(stageId)}`, label: "編集に戻る" };
}
